export var isType = function (type) {
    return function (obj) {
        return getType(obj) === "[object " + type + "]";
    };
};
// toString() 的应用：判断数据类型（因为 Array, String 等）
// https://wangdoc.com/javascript/stdlib/object.html#tostring
export var getType = function (obj) { return Object.prototype.toString.call(obj); };
export var isFn = function (val) { return typeof val === 'function'; };
export var isPlainObj = isType('Object');
export var isStr = isType('String');
export var isBool = isType('Boolean');
export var isNum = isType('Number');
export var isArr = Array.isArray;
export var isValid = function (val) { return val !== undefined && val !== null; };
